import Vue from 'vue';
import Vuex from 'vuex';

import inquery from './inquery';
import issuing from './issuing';
import notice from './notice';
import press from './press';
import badgeGallery from './badgeGallery';
// import kohveabadges from './kohveabadges';
import s4edtechbadge from './s4edtechbadge';
import aeskrbadge from './aeskrbadge';
import eduplusweek from './eduplusweek';
import alheforum from './alheforum';
import eduplusshow from './eduplusshow';
import lecoslte2025 from './lecoslte2025';
import bgwc3lecos from './bgwc3lecos';
import mainPopup from './mainPopup';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        inquery,
        issuing,
        // kohveabadges,
        // senbadges,
        s4edtechbadge,
        aeskrbadge,
        lecoslte2025,
        eduplusweek,
        alheforum,
        eduplusshow,
        notice,
        press,
        badgeGallery,
        bgwc3lecos,
        mainPopup,
    }
});
